// Helper to emit a centralized event when credits are consumed.
// Use this after credit-consuming jobs succeed to notify UI components
// (e.g., `CreditBalanceDisplay`) to refresh.

export function emitCreditsConsumed() {
  try {
    window.dispatchEvent(new CustomEvent("credits:consumed"));
  } catch (err) {
    // Defensive: window may be undefined in some SSR environments
    // but our app runs in the browser; log any unexpected errors.
    // eslint-disable-next-line no-console
    console.error("emitCreditsConsumed failed:", err);
  }
}
